import {ContentResizer} from "../util/ContentResizer";

export function init(){
  const videoBanners = document.querySelectorAll(".adrotate-giantvideo");
  if (videoBanners.length > 0) {
    for(let i = 0; i < videoBanners.length; i++) {
      const videoBanner = videoBanners[i];
      new ContentResizer({
        target: videoBanner,
        sizeReductionPercentage: 0.05,
        resizableContainer: false,
        resizeMethod: "cover",
        autoResizeDelay: 100,
      });
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/components/VideoBanner.js